(function (window, document, $) {

    $(document).ready(function () {
        if (themevars.restyling) {
            //collapse content
            var collapseContentHeight = 160;
            if ($(".docent__content").length && $(window).width() < 1024) {
                $(".docent__content").addClass("collapse-content");
                collapseContentHeight = 250;
            }

            if ($(".stijl__content").length && $(window).width() < 1024) {
                $(".stijl__content").addClass("collapse-content");
                collapseContentHeight = 500;
            }

            if ($(".collapse-content").length) {
                $(".collapse-content").moreContent({
                    height: collapseContentHeight,
                    shadow: true,
                    textClose: 'Lees meer',
                    textOpen: 'Lees minder',
                    tpl: {
                        content: '<div class="more-content"></div>',
                        contentWrap: '<div class="more-content-wrap"></div>',
                        btn: '<a class="readmore button button__secondary" type="button"></a>',
                        btnWrap: '<div class="readmore-btn-wrap"></div>',
                        controls: '<div class="readmore-controls"></div>',
                        shadow: '<div class="shadow"></div>',
                    }
                });
            }
        }
    });

}(window, document, jQuery));
